import { render, staticRenderFns } from "./DisciplineShow.vue?vue&type=template&id=d4454cea&scoped=true&"
import script from "./DisciplineShow.vue?vue&type=script&lang=js&"
export * from "./DisciplineShow.vue?vue&type=script&lang=js&"
import style0 from "./DisciplineShow.vue?vue&type=style&index=0&id=d4454cea&scoped=true&lang=scss&"
import style1 from "./DisciplineShow.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./DisciplineShow.vue?vue&type=style&index=2&id=d4454cea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4454cea",
  null
  
)

export default component.exports